import React, { useContext, useEffect, useState } from 'react';

import { Modes, Props } from './EntitiesSearch.types';

import { MapPopup } from '../MapPopup';
import { mapContext } from '../mapContext';
import { MenuButton } from '../../components/MenuButton';
import { Vehicle } from './Modes/Vehicle';
import { Route } from './Modes/Route';
import { Agency } from './Modes/Agency';

export const EntitiesSearchBody: React.FC<Props> = ({ changeTitle }) => {
  const [selectedMode, setSelectedMode] = useState<Modes | null>(null);

  useEffect(() => {
    switch (selectedMode) {
      case Modes.vehicle:
        changeTitle('Поиск ТС');
        break;
      case Modes.route:
        changeTitle('Поиск маршрута');
        break;
      case Modes.branch:
        changeTitle('Поиск предприятия');
        break;
      default:
        changeTitle('Поиск');
    }
  }, [changeTitle, selectedMode]);

  if (selectedMode === null) {
    return (
      <>
        <MenuButton onClick={() => setSelectedMode(Modes.vehicle)}>
          Поиск транспортного средства
        </MenuButton>
        <MenuButton onClick={() => setSelectedMode(Modes.route)}>
          Поиск маршрута
        </MenuButton>
        <MenuButton onClick={() => setSelectedMode(Modes.branch)}>
          Поиск предприятия
        </MenuButton>
      </>
    );
  }

  switch (selectedMode) {
    case Modes.vehicle:
      return <Vehicle />;
    case Modes.route:
      return <Route />;
    case Modes.branch:
      return <Agency />;
  }
};

export const EntitiesSearch: React.FC = () => {
  const [title, setTitle] = useState('');
  const { toggleShowEntitiesSearchPopup, showEntitiesSearchPopup } = useContext(
    mapContext
  );

  if (!showEntitiesSearchPopup) return null;

  return (
    <MapPopup label={title} onClose={toggleShowEntitiesSearchPopup}>
      <EntitiesSearchBody changeTitle={setTitle} />
    </MapPopup>
  );
};
